module.exports = __webpack_public_path__ + "img/COWBOY HAT BN.e9728d7.svg";